// extracted by mini-css-extract-plugin
var _1 = "Presets_item__4d2ad";
var _2 = "Presets_preview__ef293";
var _3 = "Presets_root__07565";
var _4 = "Presets_selected__c01c7";
export { _1 as "item", _2 as "preview", _3 as "root", _4 as "selected" }
